import React from 'react';
import { useTranslation } from 'react-i18next';

export default function AdminFooter({
  faqUrl = '/faq',
  gdprUrl = '/gdpr',
  privacyUrl = '/privacy',
  termsUrl = '/terms',
  cookiesUrl = '/cookies',
  contactEmail = 'info@vbwebb.se',
  siteUrl = 'https://vbwebb.se',
  onManageCookies = null,
  cookiesSettings = '/cookie-settings',               // optional: open your cookie modal
  brandName = 'VBWEBB',
  version = '1.1.2',
}) {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const A = ({ href, children, external }) => (
    <a
      href={href}
      target={external ? '_blank' : undefined}
      rel={external ? 'noopener noreferrer' : undefined}
      className="text-white/80 hover:text-white transition"
    >
      {children}
    </a>
  );

  return (
    <footer className="bg-neutral-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand blurb */}
          <div>
            <div className="text-xl font-bold">{brandName}</div>
            <div className="text-white/70">{t('footer.version', { version })}</div>
            <p className="mt-3 text-sm text-white/70">
              {t('footer.tagline')}
            </p>
            <div className="mt-3">
              <A href={siteUrl} external>{t('footer.links.website')}</A>
            </div>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-3">{t('footer.sections.support')}</h4>
            <ul className="space-y-2 text-sm">
              <li><A href={`mailto:${contactEmail}`}>{contactEmail}</A></li>
              <li><A href={faqUrl}>{t('footer.links.faq')}</A></li>
              <li>
                  <A href={cookiesSettings}>{t('footer.links.cookieSettings')}</A>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-3">{t('footer.sections.legal')}</h4>
            <ul className="space-y-2 text-sm">
              <li><A href={gdprUrl}>{t('footer.links.gdpr')}</A></li>
              <li><A href={privacyUrl}>{t('footer.links.privacy')}</A></li>
              <li><A href={termsUrl}>{t('footer.links.terms')}</A></li>
              <li><A href={cookiesUrl}>{t('footer.links.cookies')}</A></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-3">{t('footer.sections.resources')}</h4>
            <ul className="space-y-2 text-sm">
              <li><A href="/status">{t('footer.links.status')}</A></li>
              <li><A href="/changelog">{t('footer.links.changelog')}</A></li>
              <li><A href="/guides">{t('footer.links.guides')}</A></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-white/10 pt-4 flex items-center justify-between text-xs text-white/60">
          <span>© {year} {brandName}. {t('footer.copyright')}</span>
        </div>
      </div>
    </footer>
  );
}
